import React from "react";
import { Link } from "react-router-dom";
import logo from "../resources/balam_icon_v2.png";

export const Header = () => {
    return (
        <nav className="navbar navbar-expand-lg navbar-dark bg-dark fixed-top">
            <div className="container">
                <Link to="/#hrefInicio" className="d-flex align-items-center mb-3 mb-md-0 me-md-auto link-body-emphasis text-decoration-none">
                <img src={logo} alt="logo" width="30" height="30" className="d-inline-block align-text-top" />
                    <span className="ps-2 fs-4 navbar-brand">Balam Boox</span>
                </Link>

                <div className="collapse navbar-collapse justify-content-center" id="navbarToggler">
                    <ul className="navbar-nav mr-auto mt-2 mt-lg-0">
                        <li className="nav-item">
                            <Link className="nav-link" to="/#hrefBeneficios">Beneficios</Link>
                        </li>
                        <li className="nav-item">
                            <Link className="nav-link active" to="/#hrefUbicacion">Ubicación</Link>
                        </li>
                        <li className="nav-item">
                            <Link className="nav-link" to="/#hrefRedesSociales">Redes sociales</Link>
                        </li>
                        <li className="nav-item">
                            <Link className="nav-link fw-bold" to="/gallery">Galería</Link>
                        </li>
                    </ul>
                </div>
            </div>
        </nav>
    );
}